export default {
    getLabHandleHistoryDataTableOptions: state => state.labHandleHistoryDataTableOptions,
    getLabHandleHistoryRowActions: state => state.labHandleHistoryRowActions,
    getLabHandleHistoryHeaderFields: state => state.labHandleHistoryHeaderFields,
    getLabHandleHistorySearchFields: state => state.lanHandleHistorySearchFields,
    getLabHandleHistoryActions: state => state.labHandleHistoryActions,

    getLabDocumentHistoryRowActions: state => state.labDocumentHistoryRowActions,
    getLabDocumentHistoryHeaderFields: state => state.labDocumentHistoryHeaderFields,
}
